// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVScrollBarLine_module-MRWA34DV_scrollbar__vgN-f","thumb":"HVScrollBarLine_module-MRWA34DV_thumb__s6jCT","corner":"HVScrollBarLine_module-MRWA34DV_corner__Webx+"};